import React from 'react'

export default class IconsWarning extends React.Component {

    render() {
        let color = "#C8C5FE";
        if (this.props.color) color = this.props.color;
        let className = "icons-icon";

        return <svg className={className} style={this.props.style} width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path fillRule="evenodd" clipRule="evenodd" d="M8.25697 4.09904C9.02197 2.73904 10.979 2.73904 11.743 4.09904L17.323 14.019C18.073 15.353 17.11 16.999 15.581 16.999H4.41997C2.88997 16.999 1.92697 15.353 2.67697 14.019L8.25697 4.09904ZM11 14C11 14.2653 10.8946 14.5196 10.7071 14.7071C10.5195 14.8947 10.2652 15 9.99997 15C9.73475 15 9.4804 14.8947 9.29286 14.7071C9.10533 14.5196 8.99997 14.2653 8.99997 14C8.99997 13.7348 9.10533 13.4805 9.29286 13.2929C9.4804 13.1054 9.73475 13 9.99997 13C10.2652 13 10.5195 13.1054 10.7071 13.2929C10.8946 13.4805 11 13.7348 11 14ZM9.99997 6.00004C9.73475 6.00004 9.4804 6.1054 9.29286 6.29293C9.10533 6.48047 8.99997 6.73482 8.99997 7.00004V10C8.99997 10.2653 9.10533 10.5196 9.29286 10.7071C9.4804 10.8947 9.73475 11 9.99997 11C10.2652 11 10.5195 10.8947 10.7071 10.7071C10.8946 10.5196 11 10.2653 11 10V7.00004C11 6.73482 10.8946 6.48047 10.7071 6.29293C10.5195 6.1054 10.2652 6.00004 9.99997 6.00004Z" fill={color} />
        </svg>




    }
}        